import classNames from 'classnames';
import _ from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useSpotManager } from '../../utils/manager/spot-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { Title } from '../title';

const animateFromLeft =
  'animate__animated animate__fadeInLeft animate__delay-1s';

function Header({ singleOrder }) {
  const { analyticsHollowEvent } = useAnalytics();
  const { user, spot, orders } = useStorage();
  const { parseSpotFromOrder } = useSpotManager();
  const classes = useStyles();
  const { t } = useTranslation();

  const onPress = () => {
    analyticsHollowEvent('bill title click');
  };

  const description = useMemo(() => {
    if (spot?.prepaid) {
      return t('bill.user-your-order.prepaid', { userName: user?.name });
    }
    return t('bill.user-your-order', {
      userName: user?.name,
      count: singleOrder ? 1 : 2,
    });
  }, [user, spot]);

  return (
    <div className={classes.container}>
      <div className={classes.title} onClick={onPress} aria-hidden>
        <Title
          value={
            // aloneBill
            //   ? "Sua Conta"
            //   :
            `${spot?.name ?? parseSpotFromOrder(orders)?.name}`
          }
        />
      </div>

      <div
        className={classNames(classes.description, animateFromLeft)}
        style={{ '--animate-delay': '0.3s' }}
      >
        {!_.isEmpty(user?.token) && <span>{description}:</span>}
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    paddingTop: `max(1px, env(safe-area-inset-top))`,
    marginBottom: layoutDefaults.biggerVerticalMargin,
    // border: '1px solid blue',
  },
  title: {
    // font-size: large;
    // font-weight: bolder;
    marginTop: 46,
    // marginBottom: 28,
    // vertical-align: middle;
  },
  description: {
    textTransform: 'uppercase',
    opacity: layoutDefaults.opacity,
    marginTop: layoutDefaults.bigVerticalMargin,
  },
});

export { Header };
